'use client';

import { Star, ThumbsUp } from 'lucide-react';
import { ReviewItem } from './review-item';

interface Review {
  id: number;
  author: string;
  rating: number;
  title: string;
  content: string;
  date: string;
  helpful: number;
}

interface ReviewListProps {
  reviews: Review[];
  onMarkHelpful?: (reviewId: number) => void;
}

export function ReviewList({ reviews, onMarkHelpful }: ReviewListProps) {
  return (
    <div className="space-y-4">
      {reviews.length === 0 ? (
        <div className="rounded-lg bg-slate-800/50 p-8 text-center backdrop-blur">
          <p className="text-slate-400">No reviews yet. Be the first to share your thoughts!</p>
        </div>
      ) : (
        reviews && reviews.map((review, index) => (
          <div
            key={review.id}
            className="animate-in fade-in slide-in-from-bottom-2 duration-500"
            style={{
              animationDelay: `${index * 50}ms`,
            }}
          >
            <ReviewItem review={review} onMarkHelpful={onMarkHelpful} />
          </div>
        ))
      )}
    </div>
  );
}
